/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$(document).ready(function() {
  if($('body').hasClass('template-index')) {
    function adjustHeroAndSauces() {
      var hp_hero = document.getElementById('hp-intro__hero');
      var hp_sauces = document.getElementById('hp-intro__sauces');
    
      if (window.innerWidth >= 1025) {
        var height = hp_sauces.offsetHeight;
        var marginAdjustment = height / 2;
        hp_sauces.style.marginTop = `-${marginAdjustment}px`;
        hp_hero.style.paddingBottom = `${marginAdjustment}px`;
      } else {
        // Reset styles if the screen width is smaller than 1025px
        hp_sauces.style.marginTop = '';
        hp_hero.style.paddingBottom = '';
      }
    }
    
    $(document).on("lazybeforeunveil", function() {
      adjustHeroAndSauces();
    });
    
    $(window).on('resize', function() {
      adjustHeroAndSauces();
    });

    const banner = document.getElementById('landing-banner');
    const bottle = document.querySelector('.landing-banner__bottles');
    let position = { x: 0, y: 0 };
    let targetPosition = { x: 0, y: 0 };
    const easingFactor = 0.01; // Lowering this for more delay and smoother movement

    document.addEventListener('mousemove', (event) => {
      const mouseX = event.clientX;
      const mouseY = event.clientY;
      
      const speedX = -0.08; // Move in the opposite direction
      const speedY = -0.112; // Move in the opposite direction
      targetPosition.x = (mouseX - (window.innerWidth / 2)) * speedX;
      targetPosition.y = (mouseY - (window.innerHeight / 2)) * speedY;
    });
    
    function animate() {
      position.x += (targetPosition.x - position.x) * easingFactor;
      position.y += (targetPosition.y - position.y) * easingFactor;
      
      bottle.style.transform = `translate(${position.x}px, ${position.y}px)`;
      requestAnimationFrame(animate);
    }

    animate();


  // GSAP

    function splash_animation() {
      if (window.innerWidth >= 1025 && $('body.template-index').length) {
        gsap.registerPlugin(ScrollTrigger);
      
        gsap.to('.landing-banner__strapline', {
          scrollTrigger: {
            trigger: '.landing-banner__wrap',
            start: 'top top',
            end: '+=100%',
            scrub: true,
            once: true,
          },
          
          scale: .5,
          y: '-100%',
          onComplete: function() {
            $('body.template-index').addClass('splash-complete');
            window.scrollTo(0, 0);
            sr.sync(); 
          }
        });
  
         gsap.to('.landing-banner__logo', {
            scrollTrigger: {
                trigger: '.landing-banner__wrap',
                start: 'top top',
                end: '+=10%',
                scrub: true,
            },
            opacity: 0,
            // scale: 0.5
        });
  
        gsap.to('.landing-banner__bottles-wrap', {
            scrollTrigger: {
                trigger: '.landing-banner__wrap',
                start: 'top top',
                end: '+100%',
                scrub: true,
            },
            scale: 1.5,
           'webkitFilter': 'blur(5px)',
        });
      }
    }

     splash_animation();
    
    $(window).on('resize', function() {
      splash_animation();
    });
  };
});

function initAnnouncementHover() {
  if (!window.matchMedia('(hover: hover)').matches) return;

  const headerNavs = document.querySelector('.header-navs');
  const announcement = document.querySelector('.announcement');

  if (!headerNavs || !announcement) return;

  headerNavs.addEventListener('mouseenter', () => {
    announcement.classList.add('is-hidden');
  });

  headerNavs.addEventListener('mouseleave', () => {
    announcement.classList.remove('is-hidden');
  });
}

document.addEventListener('DOMContentLoaded', initAnnouncementHover);
document.addEventListener('shopify:section:load', initAnnouncementHover);

